import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ChangePasswordScreen } from "@/components/auth/ChangePasswordScreen";
import { useUsageHeartbeat } from "@/lib/useUsageHeartbeat";

const Splash = () => (
  <div data-testid="auth-checking" className="min-h-screen flex items-center justify-center">
    <Loader2 className="w-6 h-6 animate-spin c-muted" />
  </div>
);

const Heartbeat = () => { useUsageHeartbeat(); return null; };

export const RequireAuth = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (user.must_change_password) return <ChangePasswordScreen />;
  return <><Heartbeat />{children}</>;
};

export const RequireOwner = ({ children }) => {
  const { user, isOwner } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ChangePasswordScreen />;
  if (!isOwner) return <Navigate to="/conecta" replace />;
  return children;
};
